import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('refactor_nin_to_jira_view_schema');
	},
};
